/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import {
  ExtendedFlex,
  Formatters,
  TooltipIcon,
  Tooltip,
  Body,
} from '../../coreui';

import ScrollToSpanOnMount from '../../components/ScrollToSpanOnMount';
import DashboardTableCell from './DashboardTableCell';
import PendingDashboardActionCell from './PendingDashboardActionCell';
import PendingDashboardCancelCell from './PendingDashboardCancelCell';
import HeaderComponent from './TableHeader';
import StyledTable from './StyledTable';

const columns = (investments) => {
  const sumAmount = investments.reduce(
    (accum, item) => (accum + item.amount), 0.00,
  );

  return [
    {
      Header: <HeaderComponent>Investment</HeaderComponent>,
      accessor: 'investment',
      minWidth: 300,
      Cell: DashboardTableCell(),
      id: 'investmentUrl',
    },
    {
      Header: <HeaderComponent>Type</HeaderComponent>,
      accessor: 'type',
      Cell: DashboardTableCell(),
    },
    {
      Header: <HeaderComponent>Date</HeaderComponent>,
      accessor: 'date',
      show: false,
    },
    {
      Header: <HeaderComponent>Amount</HeaderComponent>,
      accessor: 'amount',
      Cell: DashboardTableCell(Formatters.DOLLARS_DECIMALS),
      id: 'tbdAmount',
      ...(investments.length === 0 ? {} : {
        Footer: () => {
          if (investments.length === 0) {
            return null;
          }
          return (
            <HeaderComponent>
              {numeral(sumAmount).format(Formatters.DOLLARS_DECIMALS)}
            </HeaderComponent>
          );
        },
      }),
    },
    {
      width: 200,
      Header: <HeaderComponent justify="center">Status</HeaderComponent>,
      accessor: 'status',
      Cell: DashboardTableCell(),
    },
    {
      width: 320,
      Header: <HeaderComponent justify="center">Action</HeaderComponent>,
      Cell: (props) => <PendingDashboardActionCell {...props} />,
      accessor: 'action',
    },
    {
      width: 150,
      Header: <HeaderComponent justify="center">Cancel</HeaderComponent>,
      Cell: (cellProps) => (
        <PendingDashboardCancelCell
          {...cellProps}
          // When the user removes the item from their list, React needs to
          // know that this component completely changed. Otherwise, the modal
          // stays open.
          key={`pendingInvestmentsCancelCell:${cellProps.original.id}`}
        />
      ),
      accessor: 'cancel',
      sortable: false,
    },
  ];
};

const PendingInvestmentsTable = ({
  investments,
  tooltip,
  scrollToMount,
}) => {
  if (!investments) {
    return null;
  }

  // Filter out the waitlisted investments.
  const filteredInvestments = investments.filter((item) => {
    // @TODO filter investments.
    return true || !item.fundedWaitListFlag;
  });

  return (
    <ExtendedFlex
      flexDirection="column"
      width={1}
      alignItems="center"
      mx={[50, 50, 50, 0]}
    >
      {
        scrollToMount &&
        <ScrollToSpanOnMount />
      }
      <StyledTable
        title="Pending Investments"
        tooltip={
          <>
            <TooltipIcon
              tooltipId="pendingInvestmentsTooltip"
            />
            <Tooltip id="pendingInvestmentsTooltip">
              <Body type="B5">
                {tooltip}
              </Body>
            </Tooltip>
          </>
        }
        data={filteredInvestments}
        columns={columns(filteredInvestments)}
        noDataText="You have no pending items."
      />
    </ExtendedFlex>
  );
};

PendingInvestmentsTable.propTypes = {
  investments: PropTypes.array,
  tooltip: PropTypes.node,
  scrollToMount: PropTypes.bool,
};

export default PendingInvestmentsTable;
